import { Heading } from '@chakra-ui/react'
import React from 'react'

export const Error = () => {
  return (
    <>
    <Heading textColor={'darkred'} h={'70vh'} align={'center'} >404 Page not found!</Heading>
    </>
  )
}
